import { render } from "./SupplementRecommendations.vue?vue&type=template&id=02abbdd8&scoped=true"
import script from "./SupplementRecommendations.vue?vue&type=script&lang=js"
export * from "./SupplementRecommendations.vue?vue&type=script&lang=js"

import "./SupplementRecommendations.vue?vue&type=style&index=0&id=02abbdd8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02abbdd8"]])

export default __exports__